import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "diamonds-search-form-pro" }
const _hoisted_2 = {
  key: 0,
  class: "filter-row border-b border-gray-200 py-4"
}
const _hoisted_3 = { class: "mt-2 overflow-x-auto no-scrollbar scroll-smooth flex" }
const _hoisted_4 = {
  key: 0,
  class: "filter-row border-b border-gray-200 py-4 last:border-b-0"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex gap-2 items-center" }
const _hoisted_7 = { class: "font-bold text-sm text-gray-900 tracking-tight" }
const _hoisted_8 = { class: "text-sm text-gray-500 font-light" }
const _hoisted_9 = {
  key: 0,
  class: "text-gray-400 group-hover:text-gray-500 transition-colors"
}
const _hoisted_10 = {
  key: 0,
  class: "mt-3 overflow-x-auto no-scrollbar scroll-smooth"
}
const _hoisted_11 = {
  key: 0,
  class: "mb-6 px-2"
}
const _hoisted_12 = {
  key: 7,
  class: "flex gap-4 pb-2 px-2"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center text-xs font-semibold text-gray-600"
}
const _hoisted_15 = {
  key: 1,
  class: "text-xs font-medium text-gray-700"
}
const _hoisted_16 = { class: "text-[11px] text-gray-500 tracking-wide whitespace-nowrap" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "text-[11px] text-gray-500 tracking-wide whitespace-nowrap" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "flex flex-col items-center" }
const _hoisted_21 = { class: "text-[10px]" }
const _hoisted_22 = { class: "text-[11px] text-gray-500" }
const _hoisted_23 = {
  key: 1,
  class: "mt-8 pt-8 border-t border-[#a99d8b] flex items-center justify-between gap-4"
}
const _hoisted_24 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_25 = {
  key: 1,
  class: "flex items-center gap-3"
}
const _hoisted_26 = { class: "text-[13px] uppercase tracking-widest text-[#4A5568]" }

import { computed } from "vue";
import DiamondsSearchFormIcons from "@/components/diamonds/form/diamondsSearchFormIcons.vue";
import DiamondsSearchFormNumberRange from "@/components/diamonds/form/diamondsSearchFormNumberRange.vue";
import DiamondsSearchFormRange from "@/components/diamonds/form/diamondsSearchFormRange.vue";
import DiamondsSearchFormSwitch from "@/components/diamonds/form/diamondsSearchFormSwitch.vue";
import DiamondsSearchFormList from "@/components/diamonds/form/diamondsSearchFormList.vue";
import DiamondsSearchFormPresets from "@/components/diamonds/form/diamondsSearchFormPresets.vue";
import DiamondsSearchFormTextList from "@/components/diamonds/form/diamondsSearchFormTextList.vue";
import InfoModal from "@/components/info/infoModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'diamondsSearchFormPro',
  props: {
    filters: { default: () => ({}) },
    activeFilters: { default: () => ({}) },
    singleFilterKey: { default: "" },
    isFilterDefined: {},
    isFilterOpen: {},
    toggleFilter: {},
    getFilterLabel: {},
    getActiveValueLabel: {},
    presets: { default: () => [] }
  },
  emits: ["updateFilter", "updateFilters"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const sortedFilterKeys = computed(() => {
  return Object.keys(props.filters).sort((a, b) => {
    return (props.filters[a].order || 0) - (props.filters[b].order || 0);
  });
});

const alwaysVisibleKeys = computed(() => {
  if (props.singleFilterKey) {
    return sortedFilterKeys.value.filter(key => key === props.singleFilterKey && key === 'type');
  }
  return sortedFilterKeys.value.filter(key => key === 'type');
});

const collapsibleKeys = computed(() => {
  if (props.singleFilterKey) {
    return sortedFilterKeys.value.filter(key => {
      const isTarget = key === props.singleFilterKey || (props.singleFilterKey === 'colored' && key === 'color');
      if (!isTarget) return false;
      if (key === 'type' || key === 'sortOrder' || key === 'colored') {
        return false;
      }
      if (key === 'fancy_intensity' && !props.activeFilters.colored) {
        return false;
      }
      return true;
    });
  }
  return sortedFilterKeys.value.filter(key => {
    if (key === 'type' || key === 'sortOrder' || key === 'colored') {
      return false;
    }
    if (key === 'fancy_intensity' && !props.activeFilters.colored) {
      return false;
    }
    return true;
  });
});

const showBottomFilters = computed(() => {
  if (props.singleFilterKey) {
    return props.singleFilterKey === 'fastDelivery' || props.singleFilterKey === 'sortOrder';
  }
  return true;
});

const updateFilter = (key: string, val: any) => {
  emit('updateFilter', key, val);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alwaysVisibleKeys.value, (key) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: 'always-' + key
      }, [
        (__props.filters[key])
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (__props.filters[key].type === 'icon' && __props.filters[key].view === 'list')
                  ? (_openBlock(), _createBlock(DiamondsSearchFormIcons, {
                      key: 0,
                      filter: __props.filters[key],
                      "active-value": __props.activeFilters[key],
                      onUpdate: (val) => updateFilter(key, val)
                    }, null, 8, ["filter", "active-value", "onUpdate"]))
                  : (__props.filters[key].type === 'number' && __props.filters[key].view === 'range')
                    ? (_openBlock(), _createBlock(DiamondsSearchFormNumberRange, {
                        key: 1,
                        filter: __props.filters[key],
                        "active-value": __props.activeFilters[key],
                        onUpdate: (val) => updateFilter(key, val)
                      }, null, 8, ["filter", "active-value", "onUpdate"]))
                    : ((__props.filters[key].type === 'icon' || __props.filters[key].type === 'text') && __props.filters[key].view === 'range')
                      ? (_openBlock(), _createBlock(DiamondsSearchFormRange, {
                          key: 2,
                          filter: __props.filters[key],
                          "active-value": __props.activeFilters[key],
                          onUpdate: (val) => updateFilter(key, val)
                        }, null, 8, ["filter", "active-value", "onUpdate"]))
                      : ((__props.filters[key].type === 'text' || __props.filters[key].type === 'bool') && __props.filters[key].view === 'switch')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createVNode(DiamondsSearchFormSwitch, {
                              filter: __props.filters[key],
                              "active-value": __props.activeFilters[key],
                              onUpdate: (val) => updateFilter(key, val)
                            }, null, 8, ["filter", "active-value", "onUpdate"]),
                            _createVNode(InfoModal, {
                              id: __props.filters[key].modalId,
                              value: __props.activeFilters[key]
                            }, null, 8, ["id", "value"])
                          ], 64))
                        : (__props.filters[key].type === 'text' && __props.filters[key].view === 'list')
                          ? (_openBlock(), _createBlock(DiamondsSearchFormList, {
                              key: 4,
                              filter: __props.filters[key],
                              "active-value": __props.activeFilters[key],
                              onUpdate: (val) => updateFilter(key, val)
                            }, null, 8, ["filter", "active-value", "onUpdate"]))
                          : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (__props.presets && __props.presets.length > 0 && (typeof __props.activeFilters.colored == 'undefined' || __props.activeFilters.colored !== true))
      ? (_openBlock(), _createBlock(DiamondsSearchFormPresets, {
          key: 0,
          presets: __props.presets,
          "active-filters": __props.activeFilters,
          class: "mt-2 border-b border-gray-200",
          onUpdateFilters: _cache[0] || (_cache[0] = (val) => emit('updateFilters', val))
        }, null, 8, ["presets", "active-filters"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collapsibleKeys.value, (key) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
        (__props.filters[key])
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "flex justify-between items-center cursor-pointer group",
                onClick: ($event: any) => (__props.toggleFilter(key))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", _hoisted_7, _toDisplayString(__props.getFilterLabel(key)) + ":", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(__props.getActiveValueLabel(key, __props.activeFilters[key])), 1),
                  _createVNode(InfoModal, {
                    id: __props.filters[key].modalId,
                    value: __props.activeFilters[key],
                    "stone-type": __props.activeFilters['type'] || 'earth'
                  }, null, 8, ["id", "value", "stone-type"])
                ]),
                (!__props.isFilterDefined(key))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(), _createElementBlock("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: _normalizeClass(["w-4 h-4 transition-transform duration-300", { 'rotate-180': __props.isFilterOpen(key) }]),
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M19 9l-7 7-7-7"
                        }, null, -1)
                      ]))], 2))
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_5),
              (__props.isFilterOpen(key))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (key === 'color' && __props.filters.colored)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(DiamondsSearchFormSwitch, {
                            filter: __props.filters.colored,
                            "active-value": __props.activeFilters.colored,
                            onUpdate: _cache[1] || (_cache[1] = (val) => updateFilter('colored', val))
                          }, null, 8, ["filter", "active-value"])
                        ]))
                      : _createCommentVNode("", true),
                    (key === 'color' && __props.activeFilters.colored)
                      ? (_openBlock(), _createBlock(DiamondsSearchFormList, {
                          key: 1,
                          filter: {...__props.filters[key], values: __props.filters[key].fancy_colors},
                          "active-value": __props.activeFilters[key],
                          onUpdate: (val) => updateFilter(key, val)
                        }, null, 8, ["filter", "active-value", "onUpdate"]))
                      : (__props.filters[key].type === 'icon' && __props.filters[key].view === 'list')
                        ? (_openBlock(), _createBlock(DiamondsSearchFormIcons, {
                            key: 2,
                            filter: __props.filters[key],
                            "active-value": __props.activeFilters[key],
                            onUpdate: (val) => updateFilter(key, val)
                          }, null, 8, ["filter", "active-value", "onUpdate"]))
                        : (__props.filters[key].type === 'number' && __props.filters[key].view === 'range')
                          ? (_openBlock(), _createBlock(DiamondsSearchFormNumberRange, {
                              key: 3,
                              filter: __props.filters[key],
                              "active-value": __props.activeFilters[key],
                              onUpdate: (val) => updateFilter(key, val)
                            }, null, 8, ["filter", "active-value", "onUpdate"]))
                          : ((__props.filters[key].type === 'icon' || __props.filters[key].type === 'text') && __props.filters[key].view === 'range')
                            ? (_openBlock(), _createBlock(DiamondsSearchFormRange, {
                                key: 4,
                                filter: __props.filters[key],
                                "active-value": __props.activeFilters[key],
                                onUpdate: (val) => updateFilter(key, val)
                              }, null, 8, ["filter", "active-value", "onUpdate"]))
                            : ((__props.filters[key].type === 'text' || __props.filters[key].type === 'bool') && __props.filters[key].view === 'switch')
                              ? (_openBlock(), _createBlock(DiamondsSearchFormSwitch, {
                                  key: 5,
                                  filter: __props.filters[key],
                                  "active-value": __props.activeFilters[key],
                                  onUpdate: (val) => updateFilter(key, val)
                                }, null, 8, ["filter", "active-value", "onUpdate"]))
                              : (__props.filters[key].type === 'text' && __props.filters[key].view === 'list')
                                ? (_openBlock(), _createBlock(DiamondsSearchFormTextList, {
                                    key: 6,
                                    filter: __props.filters[key],
                                    "active-value": __props.activeFilters[key],
                                    onUpdate: (val) => updateFilter(key, val)
                                  }, null, 8, ["filter", "active-value", "onUpdate"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    (__props.filters[key].values)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.filters[key].values, (label, val) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: val,
                                            class: "flex flex-col items-center cursor-pointer min-w-fit",
                                            onClick: ($event: any) => (updateFilter(key, val))
                                          }, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["w-20 h-20 rounded-full border flex items-center justify-center mb-2 transition-all duration-300", __props.activeFilters[key] === val ? 'border-brand-main border-[1.5px] bg-gray-50 shadow-sm' : 'border-gray-100 hover:border-gray-300'])
                                            }, [
                                              (key === 'color' || key === 'fancy_intensity')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(val), 1))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(val), 1))
                                            ], 2),
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(label), 1)
                                          ], 8, _hoisted_13))
                                        }), 128))
                                      : _createCommentVNode("", true),
                                    (__props.filters[key].fancy_colors)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.filters[key].fancy_colors, (label, val) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'fancy-'+val,
                                            class: "flex flex-col items-center cursor-pointer min-w-fit",
                                            onClick: ($event: any) => (updateFilter(key, val))
                                          }, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["w-20 h-20 rounded-full border flex items-center justify-center mb-2 transition-all", __props.activeFilters[key] === val ? 'border-brand-main border-[1.5px] bg-gray-50' : 'border-gray-100'])
                                            }, [
                                              _createElementVNode("div", {
                                                class: "w-14 h-14 rounded-full shadow-inner",
                                                style: _normalizeStyle({ backgroundColor: val.toLowerCase() })
                                              }, null, 4)
                                            ], 2),
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(label), 1)
                                          ], 8, _hoisted_17))
                                        }), 128))
                                      : _createCommentVNode("", true),
                                    (key === 'size' && !__props.filters[key].values)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList([0.2, 0.3, 0.4, 0.5, 0.7, 1.0, 1.5, 2.0], (s) => {
                                          return _createElementVNode("div", {
                                            key: s,
                                            class: "flex flex-col items-center cursor-pointer min-w-fit",
                                            onClick: ($event: any) => (updateFilter(key, {min: s, max: s}))
                                          }, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["w-20 h-20 rounded-full border flex items-center justify-center mb-2 transition-all", __props.activeFilters[key] && __props.activeFilters[key].min === s ? 'border-brand-main border-[1.5px]' : 'border-gray-100'])
                                            }, [
                                              _createElementVNode("div", _hoisted_20, [
                                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-1 h-6 bg-gray-300 mb-1" }, null, -1)),
                                                _createElementVNode("span", _hoisted_21, _toDisplayString(s.toLocaleString('de-DE', { minimumFractionDigits: 2 })) + " ct.", 1)
                                              ])
                                            ], 2),
                                            _createElementVNode("span", _hoisted_22, _toDisplayString(s.toLocaleString('de-DE', { minimumFractionDigits: 2 })) + " ct.", 1)
                                          ], 8, _hoisted_19)
                                        }), 64))
                                      : _createCommentVNode("", true)
                                  ]))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          (!__props.singleFilterKey || __props.singleFilterKey === 'fastDelivery')
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (updateFilter('fastDelivery', !__props.activeFilters.fastDelivery))),
                  class: "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none",
                  style: _normalizeStyle({ backgroundColor: __props.activeFilters.fastDelivery ? '#a99d8b' : '#e5e7eb' })
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out", __props.activeFilters.fastDelivery ? 'translate-x-5' : 'translate-x-0'])
                  }, null, 2)
                ], 4),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-[13px] uppercase tracking-widest text-[#4A5568]" }, "Fast-Delivery", -1))
              ]))
            : _createCommentVNode("", true),
          (!__props.singleFilterKey || __props.singleFilterKey === 'sortOrder')
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (updateFilter('sortOrder', __props.activeFilters.sortOrder === 'asc' ? 'desc' : 'asc'))),
                  class: "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none",
                  style: { backgroundColor: '#a99d8b' }
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out", __props.activeFilters.sortOrder === 'desc' ? 'translate-x-5' : 'translate-x-0'])
                  }, null, 2)
                ]),
                _createElementVNode("span", _hoisted_26, "Sort: " + _toDisplayString(__props.activeFilters.sortOrder === 'asc' ? 'Auf' : 'Ab'), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})